<template>
	<div>
		<!-- vip礼包 -->
		<el-dialog width="494px" :visible.sync="show" :append-to-body="true" @close="close()" @open="open()" :close-on-click-modal="false" :close-on-press-escape="false"  :show-close="false">
			<div class="vip_gift_dialog hide_scroll_bars">
				<img @click="close()" class="vip_gift_dialog_close_icon" src="../../../assets/icons/close_icon2.png"
					alt="" />

				<div class="vip_gift_top1">
					<div class="vip_gift_top1_tag">
						{{ user.nickName }}
					</div>
					<div class="vip_gift_top1_tag_title">
						Current VIP Level
					</div>
					<div class="vip_gift_top1_tag_lv">
						<i>{{ lvData.currentVipLevel.levelName }} </i>
					</div>
					<div class="vip_gift_top1_tag_xp_box">
						<div class="vip_gift_top1_tag_xp_num">
							{{lvData.vipAmount||0}} XP
						</div>
						<div class="vip_gift_top1_tag_xp_solid">
							<div :style="{width:(lvData.vipAmount/lvData.currentVipLevel.levelMax*100)+'%'}" class="vip_gift_top1_tag_xp_solid_h">
							</div>
						</div>
						<div class="vip_gift_top1_tag_xp_remark">
							XP {{lvData.vipAmount}} / XP {{lvData.currentVipLevel.levelMax}} TO {{lvData.nextLevel && lvData.nextLevel.levelName}}
						</div>
					</div>
					<el-popover placement="top-start" width="200" trigger="hover"
						:content="lvData.currentVipLevel.remark">
						<img slot="reference" class="vip_gift_top1_tag_xp_prompt"
							src="../../../assets/icons/prompt_icon.png" alt="" />
					</el-popover>
				</div>

				<div class="vip_gift_content">
					<div class="vip_gift_content_title">
						VIP BONUS
					</div>
					<div class="full-screen-container">
						<el-carousel 
							:interval="0" 
							arrow="always" 
							indicator-position="none"
							height="240px"
							ref="carousel"
						>
							<el-carousel-item v-for="(item, index) in weekList" :key="index">
								<div class="vip_gift_content_item">
									<div></div>
									<div>
										<div class="vip_gift_content_item_price">
											₦ {{ item.levelNumber?item.levelNumber:0 }}
										</div>
										<div class="vip_gift_content_item_btn">
											<div :class="{'disabled_hs': item.weeklyClaimed ||  Number(lvData.currentVipLevel.levelId)<Number(item.levelId) }" @click="clickCollectReward(item,1)" class="vip_gift_content_item_btn def_btn">
												 <img v-if="Number(lvData.currentVipLevel.levelId)<Number(item.levelId)" class="vip_gift_content_item_lock_icon" src="../../../assets/icons/lock_icon.png" alt="" />
												 {{ item.content }} {{ item.levelName }}
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="full-screen-container">
						<el-carousel 
							:interval="0" 
							arrow="always" 
							indicator-position="none"
							height="240px"
							ref="carousel"
						>
							<el-carousel-item v-for="(item, index) in monthList" :key="index">
								<div class="vip_gift_content_item vip_gift_content_item2">
									<div></div>
									<div>
										<div class="vip_gift_content_item_price">
											₦ {{ item.levelMonthNumber?item.levelMonthNumber:0 }}
										</div>
										<div class="vip_gift_content_item_btn">
											<div :class="{'disabled_hs':item.monthlyClaimed || Number(lvData.currentVipLevel.levelId)<Number(item.levelId) }" @click="clickCollectReward(item,2)" class="vip_gift_content_item_btn def_btn">
												<img v-if="Number(lvData.currentVipLevel.levelId)<Number(item.levelId)" class="vip_gift_content_item_lock_icon" src="../../../assets/icons/lock_icon.png" alt="" />
												{{ item.content }} {{ item.levelName }}
											</div>
										</div>
									</div>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
				</div>
				<!-- VIP BENEFITS -->
					<div class="vip_gift_content_item3">
						<div class="vip_gift_content_title">
							VIP BENEFITS
						</div>
						<div class="full-screen-container mt20">
							<img src="../../../assets/image/BENEFITS1.png" class="w675h170" mode=""></img>
						</div>
						<div class="full-screen-container mt20">
							<img src="../../../assets/image/BENEFITS2.png" class="w675h170" mode=""></img>
						</div>
						<div class="full-screen-container mt20">
							<img src="../../../assets/image/BENEFITS3.png" class="w675h170" mode=""></img>
						</div>
					</div>
					<!-- Frequently Asked Questions -->
					<div class="vip_gift_content">
						<div class="vip_gift_content_title">
							Frequently Asked Questions
						</div>
						<div @click="current === '' ? current = index : current = ''"  v-for="(item,index) in pageData2" :key="index" class="mt30 boxBg ptb29 plr39">
							<div class="flex-center">
								<div class="text-white fs30" :class="{'col-curr': current === index}">{{ item.noticeTitle }}</div>
								<i :class="current === index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" color="#667" size="12"></i>
							</div>
							<div class="fs22 text-white mt35" v-if="current === index">
								<div v-html="item.noticeContent"></div>
							</div>
						</div>
					</div>
			</div>
		</el-dialog>
		<!-- 提示弹窗 -->
		<el-dialog width="370px" :visible.sync="tipShow" :close-on-click-modal="false" :close-on-press-escape="false"
			:show-close="false">
			<div class="setpage_info_box setpage_tip_dia_box">
				<div class="setpage_tip_box">
					<img @click="tipShow=false" class="setpage_tip_item_close_icon"
						src="../../../assets/icons/close_icon.png" alt="" />
					<div class="setpage_tip_item">
						<img class="setpage_tip_item_icon" src="../../../assets/icons/vip_success.png" alt="" />

						<div class="setpage_tip_item_title2">Reward Claimed</div>

						<div class="setpage_tip_item_remark2">
							You've successfully claimed your reward. <br>
							Keep playing to unlock even more bonuses
						</div>
					</div>
					<div @click="tipShow=false" class="def_btn setpage_tip_btn">
						Continue
					</div>
				</div>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import {mapState} from 'vuex';

	export default {
		name: 'vipGiftPack',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				tipShow:false,
				pageData2:[],
				current: '',
				lvData:{
					vipAmount:0,
					currentVipLevel:{
						levelMax:0,
						levelMin:0,
						levelName:'',
					},
					nextLevel:{
						levelMax:0,
						levelMin:0,
						levelName:'',
					},
				},
				weekList:[],
				monthList:[]
			}
		},
		computed: {
			...mapState(['user']), // 映射 user 模块下的 userInfo 状态
		},
		mounted() {
			// this.open()
		},
		methods: {
			close() {
				this.$emit('close', false)
			},
			open(){
				this.getVipLevelInfo()
				this.getPageData()
			},
			getPageData(){
				this.$api.noticeList({ type: 3 }).then((res)=>{
					this.pageData2 = res.data;
				})
			},
			// 获取vip奖励信息
			getVipLevelInfo(){
				this.$api.vipLevelInfo({}).then(res => {
					this.lvData = res.data
					// 合并两个数组
					this.weekList = res.data.vipLevels.map((weekItem, index) => {
					  return {
					    ...weekItem,
					    path:'/static/menu/vip1.png',
						content:'Available from'
					  };
					});
					// 合并两个数组
					this.monthList = res.data.vipLevels.map((monthItem, index) => {
					  return {
					    ...monthItem,
					    path:'/static/menu/vip2.png',
						content:'Available from'
					  };
					});
					res.data.vipLevels.forEach(item=>{
						if(item.levelId==this.lvData.currentVipLevel.levelId+1 || item.levelId==8){
							this.lvData.nextLevel =  item
						}
					})
				})
			},
			// 领取奖励
			clickCollectReward(value,type){
				if(Number(this.lvData.currentVipLevel.levelId)>=Number(value.levelId) ){
					if(type==1 && !value.weeklyClaimed || type==2 && !value.monthlyClaimed){
						this.$api.claimReward({
							type: type,
							level: value.levelId
						}).then(res=>{
							this.tipShow = true
							this.getVipLevelInfo();
							this.$store.dispatch('GetInfo')
						})
					}
				}
			},
		},
	}
</script>


<style scoped lang="scss">
	.vip_gift_dialog {
		position: absolute;
		left: 0;
		top: 0;
		width: 494px;
		min-width: 437px;
		height: 700px;
		overflow-y: auto;
		background: #1F242F;
		border-radius: 10px;
		border: 1px solid;
		box-sizing: border-box;
		padding: 70px 0px 32px;

	}

	.vip_gift_dialog_close_icon {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 43.38px;
		height: 28.92px;
		cursor: pointer;
	}

	.vip_gift_top1 {
		width: 100%;
		height: 261.81px;
		background-image: url('../../../assets/image/vip_lv_bg.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		text-align: left;
		box-sizing: border-box;
		padding: 32px 23px 18px;
	}

	.vip_gift_top1_tag {
		font-weight: bold;
		font-size: 12px;
		color: #667182;
	}

	.vip_gift_top1_tag_title {
		font-size: 16px;
		font-weight: 500;
		color: #FFFFFF;
		margin-top: 2px;
	}

	.vip_gift_top1_tag_lv {
		font-size: 40px;
		color: #14EB74;
		font-weight: bold;
		margin-top: 20px;

	}

	.vip_gift_top1_tag_xp_box {
		text-align: left;
		margin-top: 40px;
	}

	.vip_gift_top1_tag_xp_num {
		font-size: 12px;
		color: #FFFFFF;
	}

	.vip_gift_top1_tag_xp_solid {
		width: 322px;
		height: 8px;
		background: #FDFDFD;
		border-radius: 5px;
		position: relative;
		margin-top: 4px;
		overflow: hidden;
	}

	.vip_gift_top1_tag_xp_solid_h {
		width: 20%;
		height: 100%;
		background-color: #14EB74;
		border-radius: 5px;
	}

	.vip_gift_top1_tag_xp_remark {
		font-weight: 600;
		font-size: 10px;
		color: #19AB5A;
		margin-top: 4px;
	}

	.vip_gift_top1_tag_xp_prompt {
		width: 19.19px;
		height: 19.19px;
		margin-top: 10px;
		cursor: pointer;
	}
	
	.vip_gift_content{
		width: 100%;
		box-sizing: border-box;
		padding: 24px;
		text-align: left;
	}

	.vip_gift_content_item3 {
		width: 100%;
		box-sizing: border-box;
		padding: 0 24px 24px;
		text-align: left;
	}
	
	.vip_gift_content_title{
		font-weight: 500;
		font-size: 20px;
		color: #FFFFFF;
	}
	
	.vip_gift_content_item{
		width: 100%;
		height: 221px;
		background-image: url('../../../assets/image/vip4_bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		margin-top: 15px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 0 14px 16px;
	}
	
	.vip_gift_content_item2{
		background-image: url('../../../assets/image/vip8_bg.png');
	}
	
	.vip_gift_content_item_price{
		font-weight: bold;
		font-size: 16px;
		color: #14EB74;
	}
	
	.vip_gift_content_item_btn{
		position: relative;
		width: 193px;
		height: 44px;
		font-size: 14px;
		margin-top: 17px;
	}
	
	.vip_gift_content_item_lock_icon{
		width: 18px;
		height: 18px;
		margin-right: 5px;
	}
	.disabled_hs{
		opacity: 0.6;
	}
	.w675h170{
		width: 100%;
		height: 120px;
		border-radius: 16px;
	}
	.mt20 {
		margin-top: 20px;
	}
	.flex-center {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.mt30 {
		margin-top: 30px;
	}
	.boxBg {
		background: #1F242F;
	}
	.ptb29 {
		padding: 15px 0;
	}
	.plr39 {
		padding: 0 20px;
	}
	.text-white {
		color: #fff;
	}
	.fs30 {
		font-size: 15px;
	}
	.fs22 {
		font-size: 11px;
	}
	.mt35 {
		margin-top: 17px;
	}
</style>